<template>
  <div class="user-list">
    <div class="table">
      <el-table :data="tableData" border style="width: 100%">
        <el-table-column prop="course_title" label="课程名称"> </el-table-column>
        <el-table-column prop="teacher" label="授课老师"> </el-table-column>
        <el-table-column prop="duty_teacher" label="责任老师"> </el-table-column>
        <el-table-column prop="order_money" label="课程价格"> </el-table-column>
        <el-table-column prop="play_time" label="学习时长"> </el-table-column>
        <el-table-column prop="create_time" label="购买日期"> </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button class="mid-blue" @click="toDetail(scope.row)">查看详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination
          :current-page="page_index"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="page_size"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { courseOrderList, courseOrderEdit, CourseOrderExport } from "@/api/order.js";
import { mixin } from "@/mixins/pagination.js";
export default {
  mixins: [mixin],
  props: ["userMsg"],
  data() {
    return {
      searchParam: {
        keyword_search: "",
      },
      tableData: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    addStudent() {
      this.$router.push({ path: "/teacher-add" });
    },
    toDetail(row) {
      console.log(row);
      this.$router.push({
        path: "/course-order-detail",
        query: row,
      });
    },
    async getList() {
      if (!this.userMsg.user_uuid) {
        this.$message.warning("该用户没有uuid，暂无法查询课程记录");
        return;
      }
      const param = {
        page_index: this.page_index,
        page_size: this.page_size,
        ...this.searchParam,
        user_uuid: this.userMsg.user_uuid,
      };
      console.log(param);
      const res = await courseOrderList(param);
      if (res.data instanceof Array) {
        this.tableData = res.data;
        this.total = res.total;
      }
      console.log(res);
    },
    deleteItem() {
      this.$confirm("确定要删除该老师吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // this.userOption()
        })
        .catch(() => {});
    },
  },
};
</script>

<style scoped="scoped">
.user-list {
  background: white;
  padding: 10px;
  box-sizing: border-box;
}
</style>
